// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewDisclosures-module__container--2MteF","list":"ReviewDisclosures-module__list--2w8N6","listContainer":"ReviewDisclosures-module__listContainer--2rJhO"};